jQuery(document).ready(function ($) {
    var videos = $('.video-block-responsive-start-recursively');
    if (!videos.length) {
        return;
    }
    videos.each(function(index, video_raw) {
        const video = $(video_raw);
        const video_desktop = video.data('video-url-desktop');
        const video_mobile = video.data('video-url-mobile');
        const video_type_desktop = video.data('video-type-desktop');
        const video_type_mobile = video.data('video-type-mobile');
        var source = document.createElement("source");
        source.id = "hvid";
        var w = window.matchMedia("(min-width: 550px)");

        if (w.matches) {
            source.src = video_desktop;
            source.type = video_type_desktop;
        } else {
            source.src = video_mobile;
            source.type = video_type_mobile;
        }

        video_raw.appendChild(source);
        video_raw.load();
        video.closest('.video-block-container').show();
        start_video_until_it_is_really_started_recursivly(video_raw);
    });
});

function start_video_until_it_is_really_started_recursivly(video) {
    if (video && video.paused) {
        video.play();
        setTimeout(function() {
            start_video_until_it_is_really_started_recursivly(video);
        }, 1500);
    }
}